module.exports = __webpack_public_path__ + "img/game2.b0722356.jpg";